import { render, staticRenderFns } from "./WizardActions.vue?vue&type=template&id=7c6b5846&"
import script from "./WizardActions.vue?vue&type=script&lang=ts&"
export * from "./WizardActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports